/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { queryOptions, useQuery, useSuspenseQuery } from '@tanstack/react-query'
import type {
	UseQueryOptions,
	UseQueryResult,
	UseSuspenseQueryOptions,
	UseSuspenseQueryResult,
} from '@tanstack/react-query'
import type { AxiosError, AxiosRequestConfig } from 'axios'
import { organisationPipelineConfigSystemDefaults } from '../../axios/organisationPipelineConfigSystemDefaults'
import type {
	OrganisationPipelineConfigSystemDefaultsError,
	OrganisationPipelineConfigSystemDefaultsResponse,
} from '../../types/OrganisationPipelineConfigSystemDefaults'

export const organisationPipelineConfigSystemDefaultsQueryKey = () => [{ url: '/pipeline-stage-defaults' }] as const

export type OrganisationPipelineConfigSystemDefaultsQueryKey = ReturnType<
	typeof organisationPipelineConfigSystemDefaultsQueryKey
>

/** @see backend/nexus/modules/Organisation/Http/Controllers/OrganisationPipelineConfigController.php OrganisationPipelineConfigController::systemDefaults */
export function organisationPipelineConfigSystemDefaultsQueryOptions(config?: AxiosRequestConfig) {
	return queryOptions<
		OrganisationPipelineConfigSystemDefaultsResponse,
		AxiosError<OrganisationPipelineConfigSystemDefaultsError>,
		OrganisationPipelineConfigSystemDefaultsResponse,
		OrganisationPipelineConfigSystemDefaultsQueryKey
	>({
		queryKey: organisationPipelineConfigSystemDefaultsQueryKey(),
		queryFn: ({ signal }) => organisationPipelineConfigSystemDefaults({ signal, ...config }).then(res => res.data),
	})
}

/** @see backend/nexus/modules/Organisation/Http/Controllers/OrganisationPipelineConfigController.php OrganisationPipelineConfigController::systemDefaults */
export function useOrganisationPipelineConfigSystemDefaults<
	TSelectData = OrganisationPipelineConfigSystemDefaultsResponse,
>(
	options?:
		& Partial<
			Omit<
				UseQueryOptions<
					OrganisationPipelineConfigSystemDefaultsResponse,
					AxiosError<OrganisationPipelineConfigSystemDefaultsError>,
					TSelectData,
					OrganisationPipelineConfigSystemDefaultsQueryKey
				>,
				'queryKey' | 'queryFn'
			>
		>
		& { queryKey?: readonly unknown[] },
): UseQueryResult<TSelectData, AxiosError<OrganisationPipelineConfigSystemDefaultsError>> {
	const { queryKey: customQueryKey, ...opts } = options ?? {}
	return useQuery({
		...organisationPipelineConfigSystemDefaultsQueryOptions(),
		...opts as any,
		...(customQueryKey ? { queryKey: customQueryKey as any } : {}),
	})
}

/** @see backend/nexus/modules/Organisation/Http/Controllers/OrganisationPipelineConfigController.php OrganisationPipelineConfigController::systemDefaults */
export function useOrganisationPipelineConfigSystemDefaultsSuspense<
	TSelectData = OrganisationPipelineConfigSystemDefaultsResponse,
>(
	options?:
		& Partial<
			Omit<
				UseSuspenseQueryOptions<
					OrganisationPipelineConfigSystemDefaultsResponse,
					AxiosError<OrganisationPipelineConfigSystemDefaultsError>,
					TSelectData,
					OrganisationPipelineConfigSystemDefaultsQueryKey
				>,
				'queryKey' | 'queryFn'
			>
		>
		& { queryKey?: readonly unknown[] },
): UseSuspenseQueryResult<TSelectData, AxiosError<OrganisationPipelineConfigSystemDefaultsError>> {
	const { queryKey: customQueryKey, ...opts } = options ?? {}
	return useSuspenseQuery({
		...organisationPipelineConfigSystemDefaultsQueryOptions(),
		...opts as any,
		...(customQueryKey ? { queryKey: customQueryKey as any } : {}),
	})
}
